module.exports = __webpack_public_path__ + "static/HeroVideo-809f422beb60785a9c3fdd4d530683f3.mp4";